import {applyBackgroundImage} from "../sunrise/background_img";
import {showTooManyRequestsError} from "./errors";
import {updateCheckboxSettingState} from "../settings/settings_common";

const horoscopeCheckBox = document.querySelector("#horoscope_form input");

async function getHoroscope(sign, date) {
    const urlParams = new URLSearchParams(window.location.search);
    let requestParams = new URLSearchParams({sign: sign, date: date});
    if (urlParams.has("lang")) {
        requestParams.append("lang", urlParams.get("lang"));
    }
    const url = "https://zima-backend.farawaytech.com/v1/horoscope/?" + requestParams;
    let response = await fetch(url, {
        headers: {
            'Content-Type': 'application/json'
        },
        method: "GET",
        credentials: 'include',
        timeout: 3000,
    });
    if (response !== undefined) {
        if (response.status === 200) {
            let res_json = await response.json();
            if (res_json && 'text' in res_json) {
                return res_json;
            }
        } else if (response.status === 429 || response.status === 401) {
            showTooManyRequestsError();
        }
    }
    return null;
}

export async function updateZodiacSign(target) {
    let horoscope_sign = target.getAttribute("data-value");
    const url = "https://zima-backend.farawaytech.com/v1/user/settings/solar_horoscope";
    let response = await fetch(url, {
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({sign: horoscope_sign}),
        method: "PUT",
        credentials: 'include',
        timeout: 3000,
    });
    if (response !== undefined && response.status === 200 && horoscopeCheckBox.checked) {
        await updateHoroscope(horoscope_sign);
        await applyBackgroundImage();
    }
    return null;
}

async function updateHoroscope(horoscope_sign) {
    let currentDate = new Date();
    let isoDate = currentDate.toISOString().split('T')[0];
    let horoscopeDiv = document.getElementById("horoscope");
    if (!horoscopeDiv) {
        let p1 = document.getElementById("row_start");
        let p2 = p1.nextElementSibling;
        p1.classList.add("col-span-2");
        p2.remove();
        horoscopeDiv = document.createElement("div");
        horoscopeDiv.id = "horoscope"
        p1.appendChild(horoscopeDiv);
    } else {
        horoscopeDiv.innerHTML = "";
    }
    let loader = document.createElement('div');
    loader.classList.add("circle-loader", "my-20");
    horoscopeDiv.appendChild(loader);

    let result = await getHoroscope(horoscope_sign, isoDate);
    if (result && result["text"]) {
        let sign = result["sign"]
        const imgElement = document.createElement('img');
        // Set the 'src' and 'alt' attributes
        imgElement.src = `/assets/icons/zodiac/${sign.toLowerCase()}.svg`;
        imgElement.alt = sign;
        imgElement.style.height = '2em';
        loader.classList.add("hidden");
        horoscopeDiv.appendChild(imgElement);
        const text = document.createElement('span');
        text.textContent = result["text"];
        horoscopeDiv.appendChild(text);
        horoscopeDiv.classList.add("content");
    } else {
        horoscopeDiv.className = '';
    }
}

export async function applyHoroscope() {
    updateCheckboxSettingState(horoscopeCheckBox);
    if (horoscopeCheckBox.checked) {
        let target = document.querySelector("#horoscope_signs input:checked")
        if (target) {
            let horoscope_sign = target.getAttribute("data-value");
            await updateHoroscope(horoscope_sign);
        }
    } else {
        const e = document.getElementById("horoscope");
        if (e) {
            e.className = "";
            e.innerHTML = "";
        }
    }
}